<template>
	<div class="merchant_content">
		<div class="detail_title" @click="$router.go(-1)">
			<span class="icon LEFTARROW mr_8"></span>
			<h3 class="title_m">{{ $t('merchant.menu_2.menu1') }}</h3>
		</div>
		<accordion v-for="item in noticeList" :key="item.seq">
			<accordion-item>
				<template v-slot:accordion-trigger>
					<div class="d_flex align_items_center mb_8">
						<span class="NOTICE icon"></span>
						<span class="fs_14">{{
							$dayjs(item.regdate).format('YYYY.MM.DD')
						}}</span>
					</div>
					<p>{{ item.title }}</p>
				</template>
				<template v-slot:accordion-content>
					<div class="notice-accordion-content">
						<!--						{{ item.content }}-->
						<div v-html="item.content"></div>
					</div>
				</template>
			</accordion-item>
		</accordion>
		<!--		<pagination-->
		<!--			:totalCount="pageNavigation.total_count"-->
		<!--			:totalPage="pageNavigation.total_page"-->
		<!--			:curPage="pageNavigation.cur_page"-->
		<!--			:point="pageNavigation.point"-->
		<!--			:firstPage="pageNavigation.first_page"-->
		<!--			:lastPage="pageNavigation.last_page"-->
		<!--			@change="pageChangeHandler"-->
		<!--		></pagination>-->
	</div>
</template>
<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
// import pagination from '@/components/Pagination';
import { fetchFaqList, fetchFaqTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
export default {
	name: 'SetupNotice',
	emits: ['showList'],
	components: {
		Accordion,
		AccordionItem,
		// pagination,
	},
	data() {
		return {
			faqTypeList: [],
			noticeList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	computed: {
		faqNotice() {
			return this.faqTypeList.find(item => {
				return item.name.toLowerCase() === 'notice';
			});
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},
		async loadFaqTypeList() {
			const { data } = await fetchFaqTypes().catch(commonError);
			this.faqTypeList = data;
		},
		async loadNoticeList() {
			const params = {
				type_seq: this.faqNotice.seq,
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.noticeList = data;
			this.pageNavigation = page_navigation;
		},
		// pageChangeHandler(pageNo) {
		// 	this.curPage = pageNo;
		// 	this.loadNoticeList();
		// },
	},
};
</script>
